var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14L12 10M12 10L8 14M12 10V21M7.5 17H4.66667C2.64162 17 1 15.3285 1 13.2667C1 11.2048 2.64162 9.53333 4.66667 9.53333L4.6817 9.53336C4.91754 5.88493 7.89871 3 11.5417 3C14.5411 3 17.0918 4.95566 18.0311 7.68295C18.1582 7.67217 18.2868 7.66667 18.4167 7.66667C20.948 7.66667 23 9.756 23 12.3333C23 14.9107 20.948 17 18.4167 17H16",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload1);
export default __webpack_public_path__ + "static/media/upload_1.bc90ac67aa239ee908883f5345f969c5.svg";
export { ForwardRef as ReactComponent };